import { Component, AfterViewInit, ElementRef, EventEmitter, Input, OnInit, OnChanges, Output, ViewChild, SimpleChanges } from '@angular/core';

import { ApiError, BaseFilterCollapse, BaseFilterCollapseService, MessageService } from '../../../core';
import { CondicaoPagamentoFilter } from './condicao-pagamento-filter';
import { condicaoPagamentoSituacoes, condicaoPagamentoAtiva } from '../condicao-pagamento-situacao';
import { FormaPagamento, FormaPagamentoCrudHttpService } from '../../forma-pagamento';

@Component({
    selector: 'sgt-condicao-pagamento-filter',
    templateUrl: './condicao-pagamento-filter-collapse.component.html',
    styleUrls: ['./condicao-pagamento-filter-collapse.component.less']
})
export class CondicaoPagamentoFilterCollapseComponent implements BaseFilterCollapse, OnInit, OnChanges, AfterViewInit {
    @Input() isCollapsedInDefault = false;
    isCollapsedIn = false;
    @ViewChild('filterCollapse') filterCollapse: ElementRef;
    collapseIcon = 'fas fa-caret-down';
    isFilterDirty = true;


    @Input() filter: CondicaoPagamentoFilter;
    @Output() filterInitialized = new EventEmitter<any>();
    situacoes = condicaoPagamentoSituacoes;
    formasPagamentos: FormaPagamento[];

    constructor(private baseFilterCollapseService: BaseFilterCollapseService,
                private messageService: MessageService,
                private formaPagamentoCrudHttpService: FormaPagamentoCrudHttpService) { }

    ngOnInit() {
        this.initFilter();
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'isCollapsedInDefault') {
                if (changes[propName].isFirstChange) {
                    setTimeout(() => {
                        this.isCollapsedIn = changes[propName].currentValue;
                    }, 100);
                }
            }
        }
    }

    ngAfterViewInit() {
      if (!this.isCollapsedInDefault) {
        jQuery(this.filterCollapse.nativeElement).css('display', 'none');
      }
    }

    /** Seta os filtros padrões */
    private setDefaultFilters() {
        this.filter.situacao = condicaoPagamentoAtiva.id;
        this.isFilterDirty = true;
    }

    /** Inicializa o filtro */
    private initFilter() {
        this.setDefaultFilters();

        const p1 = this.searchFormasPagamentos();
        Promise.all([p1])
            .then(() => {
                this.filterInitialized.emit(); // Emitindo o evento de que o filtro foi inicializado
            })
            .catch(() => {});
    }

    /** Pesquisa as formas de pagamentos */
    private searchFormasPagamentos(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.formasPagamentos = [];
            this.formaPagamentoCrudHttpService.search()
                .subscribe(
                    formasPagamentos => {
                        this.formasPagamentos = formasPagamentos;
                        resolve();
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Erro ao pesquisar as formas de pagamentos para o filtro');
                        reject();
                    }
                );
        });
    }

    /** Abre/Fecha o filtro */
    toggleCollapse() {
        this.baseFilterCollapseService.toggleCollapse(this);
    }

    /** Abre o filtro */
    open() {
        this.baseFilterCollapseService.open(this);
    }

    /** Fecha o filtro */
    close() {
        this.baseFilterCollapseService.close(this);
    }

    /** Limpa o filtro */
    clear() {
        this.baseFilterCollapseService.clear(this);

        this.setDefaultFilters();
    }
}
